import { useEffect, useState } from 'react';
import CookieStorage from '../../utils/CookieStorage';
import constants from '../../config/constants';

export const useCookiesPopover = ({ regionCode, store }) => {
  const [visible, setVisible] = useState(false);

  const isLegalBannerAccepted = () => {
    return CookieStorage.getCookie(constants.LEGAL_BANNER);
  };

  useEffect(() => {
    setVisible(!isLegalBannerAccepted());
  }, []);

  const acceptCookie = () => {
    CookieStorage.setCookie({
      name: constants.LEGAL_BANNER,
      value: 'true',
      regionCode,
      store,
      expiryDays: 30,
    });
    setVisible(false);
  };
  return { visible, setVisible, acceptCookie };
};
